import { forwardRef } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

const CustomButton = forwardRef(function CustomButton({ style, sx, children, disabled, loading, type, variant = 'contained', onClick = () => {} }, ref) {
    return (
        <LoadingButton
            ref={ref}
            style={style}
            sx={sx}
            loading={loading}
            type={type}
            variant={variant}
            size="large"
            onClick={onClick}
            disabled={disabled}
            fullWidth
        >
            {children}
        </LoadingButton>
    );
});

export default CustomButton;
